import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

const StyledCustomResources = styled(Box)`
  display: flex;
  flex-direction: column;
  .text-label {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-weight: 400;
  }
`;

export { StyledCustomResources };
